<template>
  <BravadoTheme class="layout layout--default">
    <ClientOnly>
      <TopNotification />
    </ClientOnly>
    <WarRoomMobileAppBannerTop v-if="$device.isMobile && !isJobsBannerVisible" />
    <Header />
    <div class="layout__container">
      <div class="layout__content">
        <div class="layout__content-wrapper">
          <Nuxt />
        </div>
        <ClientOnly>
          <HeaderMenuNotifications v-if="$auth.loggedIn" class="layout__notifs" />
        </ClientOnly>
        <GlobalFooter v-if="isFooterVisible" class="layout__footer" />
      </div>
    </div>
    <GlobalComponents />
  </BravadoTheme>
</template>

<script lang="ts">
import { defineComponent } from '@nuxtjs/composition-api';
import WarRoomJobApplicationMixin from '@/components/partials/war-room/WarRoomJobApplicationBanner/WarRoomJobApplicationMixin';
import Footer from '@/components/global/Footer/Footer.vue';
import defaultLayoutMixin from '~/layouts/defaultLayoutMixin';

export default defineComponent({
  name: 'LayoutDefault',
  components: {
    HeaderMenuNotifications: () =>
      import('@/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotifications.vue'),
    // We include footer component without async, otherwise styles of footer will be loaded in external chunk,
    // but in prune mode (for crawler) it wouldn't and footer won't have styles at all
    GlobalFooter: Footer,
  },
  mixins: [defaultLayoutMixin, WarRoomJobApplicationMixin],
});
</script>

<style lang="scss" scoped>
.layout {
  position: relative;
  z-index: 1;

  &__container {
    z-index: 1;
    position: relative;

    @include mq('md') {
      display: flex;
    }
  }

  &__content {
    width: 100%;

    @include mq('md') {
      flex: 1;
    }
  }

  &__content-wrapper {
    width: 100%;
    position: relative;
  }

  &__notifs {
    @include mq('sm') {
      display: none;
    }
  }
}
</style>
